import { Button, Col, Form, Row, Space } from "antd";
import React from "react";
import { useForm } from "react-hook-form";
import { DateField, FilterInputWithBlank, getBlankFilterFieldname, InputAutocompleteField, InputField, resolveBlankFilterValue } from "../../../atoms/FormElement";
import type { OwnerFilterConfig } from "../../../../hooks/useGetOwners";
import { datePlaceholderddmmyyFormat } from "../../BookingForm/components/utils";

type ReceiptsAdditionalFiltersProps = {
  setReceiptNoFilter: (v: string | null) => void;
  setTenantNameFilter: (v: string | null) => void;
  setInvoiceNumber: (v: string | null) => void;
  setBankRefFilter: (v: string | null) => void;
  setDocumentNoFilter: (v: string | null) => void;
  setPaymentTypeFilter: (v: { value: string; label: string } | null) => void;
  setErpReceiptIdFilter: (v: string | null) => void;
  setErpTenantIdFilter: (v: string | null) => void;
  setErpInvoiceNumberFilter: (v: string | null) => void;
  setPaidDateFrom: (v: any) => void;
  setPaidDateTo: (v: any) => void;
  paidDateFrom?: any;
  paidDateTo?: any;
  filterReset: () => void;
  onAfterFilterSubmit?: () => void;
  ownerFilterOptions?: OwnerFilterConfig[];
  onOwnerSelect?: (value: any, option?: any) => void;
  resetOwner?: any;
  ownerFilterOption?: any;
};

const ReceiptsAdditionalFilters: React.FC<ReceiptsAdditionalFiltersProps> = (props) => {
  const { control, handleSubmit, setValue, reset } = useForm({});

  const {
    setReceiptNoFilter,
    setTenantNameFilter,
    setInvoiceNumber,
    setBankRefFilter,
    setDocumentNoFilter,
    setErpReceiptIdFilter,
    setErpTenantIdFilter,
    setErpInvoiceNumberFilter,
    setPaidDateFrom,
    setPaidDateTo,
    paidDateFrom,
    paidDateTo,
    filterReset,
    onAfterFilterSubmit,
    ownerFilterOptions,
    onOwnerSelect,
    resetOwner,
    ownerFilterOption,
  } = props;

  const ownerField = ownerFilterOptions?.[0];

  const onFilterSubmit = (e: any) => {
    setReceiptNoFilter(e?.receiptNo || null);
    setTenantNameFilter(e?.tenantName || null);
    setInvoiceNumber(e?.invoiceNumber || null);
    setBankRefFilter(e?.bankName || null);
    setDocumentNoFilter(e?.documentNo || null);
    setErpReceiptIdFilter(resolveBlankFilterValue(e?.erpReceiptId, e?.erpReceiptIdBlank));
    setErpTenantIdFilter(resolveBlankFilterValue(e?.erpTenantId, e?.erpTenantIdBlank));
    setErpInvoiceNumberFilter(resolveBlankFilterValue(e?.erpInvoiceNumber, e?.erpInvoiceNumberBlank));
    setPaidDateFrom(e?.paidDateFrom || null);
    setPaidDateTo(e?.paidDateTo || null);
    onAfterFilterSubmit?.();
  };

  const resetAllFields = () => {
    reset();
    setValue(getBlankFilterFieldname("erpTenantId"), false);
    setValue(getBlankFilterFieldname("erpReceiptId"), false);
    setValue(getBlankFilterFieldname("erpInvoiceNumber"), false);
    filterReset();
  };

  return (
    <Form layout="vertical" className="bf-main" onFinish={handleSubmit(onFilterSubmit)}>
      <Row gutter={6}>
        {ownerField && ownerField.options.length > 0 && (
          <Col span={24}>
            <InputAutocompleteField
              initValue={ownerField.defaultValue}
              onSelect={onOwnerSelect}
              filterOption={ownerFilterOption}
              options={ownerField.options}
              fieldname={ownerField.name}
              label={ownerField.label}
              control={control}
              style={{ width: "100%" }}
              setValue={setValue}
              iProps={{ placeholder: ownerField.placeholder }}
              valueGot={resetOwner?.includes("reset") && ownerField.defaultValue}
            />
          </Col>
        )}

        <Col span={12}>
          <InputField
            fieldname="receiptNo"
            label="Receipt No"
            control={control}
            iProps={{ placeholder: "Receipt No" }}
            initValue=""
          />
        </Col>
        <Col span={12}>
          <InputField
            fieldname="invoiceNumber"
            label="Invoice Number"
            control={control}
            iProps={{ placeholder: "Invoice Number" }}
            initValue=""
          />
        </Col>
        <Col span={12}>
          <InputField
            fieldname="tenantName"
            label="Tenant Name"
            control={control}
            iProps={{ placeholder: "Tenant Name" }}
            initValue=""
          />
        </Col>
        <Col span={12}>
          <InputField
            fieldname="bankName"
            label="Bank Name"
            control={control}
            iProps={{ placeholder: "Bank Name" }}
            initValue=""
          />
        </Col>
        <Col span={12}>
          <InputField
            fieldname="documentNo"
            label="Document No"
            control={control}
            iProps={{ placeholder: "Document No" }}
            initValue=""
          />
        </Col>
        <Col span={12}>
          <FilterInputWithBlank fieldname="erpReceiptId" label="ERP Receipt Id" control={control} />
        </Col>
        <Col span={12}>
          <FilterInputWithBlank fieldname="erpTenantId" label="ERP Customer Id" control={control} />
        </Col>
        <Col span={12}>
          <FilterInputWithBlank fieldname="erpInvoiceNumber" label="ERP Invoice Id" control={control} />
        </Col>
        <Col span={12}>
          <DateField
            control={control}
            setValue={setValue}
            label="Paid Date From"
            fieldname="paidDateFrom"
            iProps={{ format: datePlaceholderddmmyyFormat, placeholder: "Date From" }}
            valueGot={paidDateFrom}
          />
        </Col>
        <Col span={12}>
          <DateField
            control={control}
            setValue={setValue}
            label="Paid Date To"
            fieldname="paidDateTo"
            iProps={{ format: datePlaceholderddmmyyFormat, placeholder: "Date To" }}
            valueGot={paidDateTo}
          />
        </Col>
        <Col span={24}>
          <Space style={{ position: "fixed", bottom: "10px", right: "5px" }}>
            <Button size="small" style={{ marginTop: "10px" }} className="ef-approve-btn" htmlType="submit">
              Submit
            </Button>
            <Button
              size="small"
              style={{ marginTop: "10px" }}
              onClick={resetAllFields}
              className="ef-reject-btn"
              htmlType="button"
            >
              Reset
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};

export default React.memo(ReceiptsAdditionalFilters);
